export default {
  segment_labels: {
    active: 'Aktiiviset',
    cancelled: 'Peruutetut',
    completed: 'Valmiit',
  },
};
